import gql from 'graphql-tag';

export default gql`
  query($slug: String) {
    getEvent(slug: $slug) {
      id
      header_desktop
      header_mobile
      visual_desktop
      visual_mobile
      category {
        id
        detail {
          label
          slug
        }
      }
      fb_cover
      blocks
      detail {
        fb_title
        fb_date
        fb_location
        fb_cta_label
        fb_cta_url
        name
        date
        introduction
        content
        tags
        description
        section_instagram_title
        meta_og_title
        meta_og_description
        meta_og_url
        links {
          text
          url
        }
      }
    }
  }
`;
